import "./editTodo.scss";
import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { EditTodo } from "../../services/todoService";
import DateChooser from "../dateChooser/dateChooser";
import PrioritySelector from "../prioritySelector/prioritySelector";
import IconButton from "../iconButton/iconButton"
import CheckIcon from "../../assets/images/check.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";

export default function EditTodoComponent({text, todoId, currentPriority, currentDate, onCancel, afterEditTodo}) {
  const inputRef = useRef(null);
  const [todo, setTodo] = useState(text);
  const [dueDate, setDueDate] = useState(currentDate);
  const [priority, setPriority] = useState(currentPriority);
  const [loading, setLoading] = useState(false);
  const date = FaToEnDigits(dueDate.format("YYYYMMDD"));

  const handleEditTodo = (e) => {
    setTodo(e.target.value);
  }
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      onCancel();
    }
    if (e.key === "Enter") {
      e.preventDefault();
      editTodo();
    }
  }

  const editTodo = async () => {
    if (todo !== "") {
      try {
        setLoading(true);
        await EditTodo(todoId, todo, date, priority);
        setLoading(false);
        setTodo("");
        afterEditTodo();
      } catch (err) {
        setLoading(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  }

  return (
    <div className={`editTodo ${priority === 1 ? "high" : priority === 2 ? "medium" : "low"}`}>
      <div className="editTodoOperations">
        <div className="editTodoInputWrapper">
          <div className="status"></div>
          <input
            className="editTodoInput"
            ref={inputRef} 
            onChange={ (e) => handleEditTodo(e)}
            value={todo}
            rows={1}
            onKeyDown = {e=>handleKeyDown(e)}
            autoFocus
          />
        </div>
        <div className="editTodoOptions">
          <DateChooser label="تاریخ انجام:" date={dueDate} setDate={setDueDate} minDate={0} />
          <PrioritySelector priority={priority} onSelect={(newPriority) => setPriority(newPriority)} />
        </div>
      </div> 
      <div className="editTodoIconWrapper">
        <IconButton icon={CheckIcon} tooltip="ثبت" onClick={() => editTodo()} loading={loading} className="editTodoButton" />
        <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={() => onCancel()} className="editTodoButton" />
      </div>
    </div>
  );
}
